var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("body"),_vm._v(" "),(_vm.model)?_c('div',[_c('ul',{staticClass:"col-md-12"},_vm._l((_vm.attachments),function(attachment,index){return _c('li',{key:index},[_c('a',{attrs:{"target":"_blank","href":_vm.getAttachmentPath(attachment)}},[_vm._v(_vm._s(attachment.AttachmentName))])])}),0),_vm._v(" "),_c('br',{staticStyle:{"clear":"both"}})]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d743460c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Invoices/cells/attachments-details.vue
// module id = hFsW
// module chunks = 12